import Header from "./Header";
import Footer from "./Footer";
import MobileBookingBar from "@/components/MobileBookingBar";

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main id="main" className="flex-1 pb-20 lg:pb-0">{children}</main>
      <Footer />
      <MobileBookingBar />
    </div>
  );
}
